// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"453":"3a9651b9","888":"7094d614"}[chunkId] + ".js";
};